<template lang="pug">
    .poi-search
        el-autocomplete(size="small" v-model="keyword" :fetch-suggestions="querySearch" placeholder="搜索股票" :trigger-on-focus="false" @select="handleSelect" suffix-icon="el-icon-search" clearable)
</template>

<script>
import storeMixin from '../store/mixin';
export default {
    props: {},
    mixins: [storeMixin],
    data() {
        return {
            keyword: null,
            item: null,
        };
    },
    methods: {
        async querySearch(queryString, cb) {
            queryString = queryString.trim();
            if (!queryString) return cb(null);

            try {
                const { data } = await this.REQUEST({
                    url: `v2/finance/stock/list?q=${queryString}`,
                });
                const recommends =
                    data.items &&
                    data.items.map(item => {
                        item.value = item.name;
                        return item;
                    });
                cb(recommends);
            } catch (e) {
                cb(null);
            }
        },
        handleSelect(item) {
            this.item = item;
            if (!item.code) return;
            this.$router.push({ path: `/stock/${item.code}` });
            this.keyword = '';
        },
    },
    mounted() {},
};
</script>

<style lang="stylus">
#canvas
    border-radius 10px
</style>
